import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useHistory, useLocation } from 'react-router-dom';

import { insightsRouteConfig } from 'src/app/graph/routes';
import { filterTypes } from 'src/components/common/filterProvider/FilterProvider';
import { useRouteParams } from 'src/hooks/useRouteParams';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';
import { TimeRangeOption } from 'src/lib/config/timeRangeOptions';
import { CustomTimeRange } from 'src/lib/date/date';
import { mergeQueryParams } from 'src/lib/routing';

import { InsightsNoSearchResults } from './insightsNoSearchResults/InsightsNoSearchResults';
import { SearchFilter } from './searchFilter/SearchFilter';

interface SubgraphsListProps {
  range: TimeRangeOption;
  bounds: CustomTimeRange;
  filter: filterTypes;
  graphId: string;
  graphVariant: string;
  clientFilterCount?: number;
}

export const SubgraphsList = (props: SubgraphsListProps) => {
  const { subgraphSearch } = useRouteParams(insightsRouteConfig);
  const { graphId, graphVariant } = props;

  const [inViewRef] = useInView();
  const location = useLocation();
  const history = useHistory();
  const trackCustomEvent = useTrackCustomEvent();

  const [subgraphSearchInputValue, setSubgraphSearchInputValue] = useState(
    subgraphSearch ?? '',
  );

  const resetSubgraphSearchInputValue = () => {
    setSubgraphSearchInputValue('');
  };

  return (
    <div className="flex h-full flex-col" ref={inViewRef}>
      <div className="flex items-center">
        <SearchFilter
          placeholderText="Search for a subgraph"
          inputValue={subgraphSearchInputValue}
          onInputChange={setSubgraphSearchInputValue}
          onSearch={(search: string) => {
            history.replace({
              ...location,
              search: mergeQueryParams(location.search, {
                subgraphSearch: search,
                subgraphsPage: 0,
                subgraphsAfter: undefined,
                subgraphsBefore: undefined,
              }),
            });

            trackCustomEvent({
              category: 'Insights L3 Subgraphs List',
              action: 'executed_subgraphs_search',
            });
          }}
          onClear={() => {
            resetSubgraphSearchInputValue();
            trackCustomEvent({
              category: 'Insights L3 Subgraphs List',
              action: 'cleared_subgraphs_search',
            });
          }}
        />
      </div>
      <InsightsNoSearchResults
        entity="Subgraph"
        resetSearch={resetSubgraphSearchInputValue}
        graphId={graphId}
        graphVariant={graphVariant}
      />
    </div>
  );
};
